module.exports = __webpack_public_path__ + "static/img/secondaryzhogyangbianyi.46999cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/secondaryzhogyangbianyi.jpg
// module id = +LGK
// module chunks = 46